var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialYoutube = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14.215,
    viewBox: "0 0 20 14.215",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social_youtube",
    transform: "translate(-0.001 -4.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M17.294,4.889a102.034,102.034,0,0,0-14.589,0C1.265,5.05.279,6.8.172,8.134a37.89,37.89,0,0,0,0,7.183C.28,16.648,1.242,18.41,2.706,18.6a108.027,108.027,0,0,0,14.589,0c1.417-.246,2.426-1.947,2.535-3.279a39.754,39.754,0,0,0,0-7.358C19.72,6.627,18.925,4.949,17.294,4.889ZM7.5,15.272V8.1l6.25,3.585Z",
    fill: "#0d47a1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social_youtube.17a329364d83ee2afb046ac8afc41bbe.svg";